const mediaQueries = {
  sm: 768,

  maxWidth: (str: number) => `(max-width: ${px(str)})`,
  minWidth: (str: number) => `(min-width: ${px(str)})`,
};
function px(unit: number | string) {
  if (typeof unit === 'string') return unit;
  return `${unit}px`;
}

export const deviceTypes = {
  mobile: 'mobile',
  desktop: 'desktop',
} as const;
export default mediaQueries;
